<template>
  <v-card>
    <ValidateAll ref="form">
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" md="6">
              <div class="headline">{{title()}}</div>
              <br />
              <!-- form goes here -->
              <v-skeleton-loader
                :loading="loading"
                class="actions__left"
                type="list-item-two-line,list-item-two-line, actions"
              >
                <Validate name="Nama" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Name"
                    label="Nama"
                    :error-messages="errors"
                    placeholder="Nama"
                    v-model="form.Name"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
                <Validate name="Username" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Username"
                    label="Username"
                    :error-messages="errors"
                    placeholder="Username"
                    v-model="form.Username"
                    hide-details="auto"
                    outlined
                    required
                    dense
                    disabled
                  ></v-text-field>
                </Validate>
                <Validate name="Email" rules="required|email" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Email"
                    label="Email"
                    :error-messages="errors"
                    placeholder="Email"
                    v-model="form.Email"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
                <Validate
                  name="Password"
                  :rules="!!form.Password?'required':''"
                  #default="{ errors }"
                >
                  <v-text-field
                    v-model="form.Password"
                    label="Password"
                    name="password"
                    type="password"
                    class="mb-3"
                    placeholder="Password"
                    hide-details="auto"
                    :error-messages="errors"
                    outlined
                    dense
                  ></v-text-field>
                </Validate>
                <Validate
                  name="Re-Password"
                  :rules="!!form.Password?'required|same_as:@Password':''"
                  #default="{ errors }"
                >
                  <v-text-field
                    v-model="form.Repassword"
                    label="Ketik Password Kembali"
                    name="Repassword"
                    type="password"
                    class="mb-3"
                    placeholder="Password"
                    hide-details="auto"
                    :error-messages="errors"
                    outlined
                    dense
                  ></v-text-field>
                </Validate>
                <Validate name="Sekolah" #default="{ errors }">
                  <v-text-field
                    v-show="showSekolah"
                    class="mb-3"
                    name="Sekolah"
                    label="Sekolah"
                    :error-messages="errors"
                    placeholder="Sekolah"
                    v-model="namaSekolah"
                    hide-details="auto"
                    outlined
                    required
                    dense
                    disabled
                  ></v-text-field>
                </Validate>
                <v-btn color="primary" @click="save()" :loading="saving">
                  <v-icon>mdi-content-save</v-icon>Simpan
                </v-btn>
              </v-skeleton-loader>
            </v-col>
            <v-divider vertical class="hidden-xs-only" />
            <v-col cols="12" md="6" class="mr-n1"></v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </ValidateAll>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    saving: false,
    loading: false,
    showSekolah: false,
    form: {
      Name: "",
      Username: "",
      Email: "",
      Password: "",
      Repassword: "",
      GroupID: "",
      IDSekolah: "",
      Status: false
    },
    namaSekolah: ""
  }),
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", ["isPenggunaLoading"])
  },
  methods: {
    async save() {
      const valid = await this.$refs.form.validate();
      // if (this.form.Password != this.form.Repassword) {
      //   return this.$dialog.notify.error("Password tidak sama.");
      // }
      if (!valid) return;
      this.form.Status = this.form.Status ? 1 : 0;
      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menyimpan data?"
      });
      if (!confirmation) return;

      this.saving = true;
      this.$axios
        .post("/user", this.form)
        .then(res => {
          this.$dialog.notify.success(res.data.Message, {
            ...this.app.notification
          });
          this.$router.push("/pengaturan/profil");
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    reset() {
      // Object.assign(this.$data, this.$options.data());
      this.$refs.form.reset();
    },
    title() {
      return "Profil Pengguna";
    },

    ...mapActions("list", ["refreshGrup", "refreshSekolah"])
  },
  async mounted() {
    this.refreshGrup();
    this.refreshSekolah();
    let user = this.$session.get.user();
    this.user = user;
    let id = this.user.id;
    let idSekolah = this.user.idSekolah;
    if (id) {
      this.loading = true;
      this.$axios
        .get(`/user/${id}`)
        .then(res => {
          this.loading = false;
          this.form = { ...this.form, ...res.data.Data };
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        });
    }
    if (idSekolah) {
      this.loading = true;
      this.$axios
        .get(`/administration/sekolah/${idSekolah}`)
        .then(res => {
          this.loading = false;
          this.namaSekolah = res.data.Data.Nama;
          this.showSekolah = true;
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        });
    }
  }
};
</script>

<style>
</style>